import type { ChartOptions } from 'chart.js';
import { ANALYTICS_AXIS_COLOR, ANALYTICS_GRID_COLOR, ANALYTICS_TOOLTIP_BG } from './AnalyticsColors';

const baseTooltip = {
  backgroundColor: ANALYTICS_TOOLTIP_BG,
  padding: 12,
  cornerRadius: 8,
} as const;

export const baseBarOptions: ChartOptions<'bar'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: baseTooltip,
  },
  scales: {
    x: { grid: { display: false } },
    y: {
      beginAtZero: true,
      grid: { color: ANALYTICS_GRID_COLOR },
      ticks: { color: ANALYTICS_AXIS_COLOR },
    },
  },
};

export const basePieOptions: ChartOptions<'pie'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'right', labels: { boxWidth: 10, boxHeight: 10, font: { size: 11 } } },
    tooltip: baseTooltip,
  },
};
